// const faqDataApp = [
//   {
//     title: "1. Why can't my T310 printer connect to my cell phone's Bluetooth?",
//     details: [
//       {
//         theme:
//           "Be sure to connect the Bluetooth in the Labelift App interface and not in the phone settings.",
//       },
//     ],
//   },
// {
//   title:
//     "2. Is the T310 printer connected to a computer wirelessly via Bluetooth?",
//   details: [
//     {
//       theme:
//         "Yes, first make sure that the computer has turned on the Bluetooth mode, open the computer version of lablelife software, click on the new tab, click on the software page at the bottom of the printer with Bluetooth logo can be connected.",
//     },
//   ],
// },
// {
//   title:
//     "3. Why can't my computer connect to the T310 machine using a USB cable?",
//   details: [
//     {
//       theme:
//         "First of all, please check whether the latest version of the driver is installed on your computer (please find the download and installation method of the driver at the top of this page).",
//     },
//     {
//       theme:
//         "If there is no problem in the one steps, please restart the computer and try again, or contact our customer service to help you solve the problem.",
//     },
//   ],
// },
// {
//   title: "4. Why does the machine's red light keep blinking?",
//   details: [
//     {
//       theme:
//         "1. Ribbon or label paper is exhausted, please replace the new supplies.",
//     },
//     {
//       theme:
//         "2. Label size is set incorrectly, ensure that the computer and the software of the size of the label set the same.",
//     },
//     {
//       theme:
//         "3. Label paper is stuck in the printer, open the printer cover, check the status.",
//     },
//     {
//       theme:
//         "If the above steps are to exclude the problem has not been resolved, please contact our customer service staff.",
//     },
//   ],
// },
// {
//   title: "5. Why are the printed labels not clear?",
//   details: [
//     {
//       theme:
//         "1. There is dust on the print head/print roller, clean the above 2 parts.",
//     },
//     {
//       theme:
//         "2. Adjust the printing concentration and printing speed, try printing consistency up and speed down until it prints clearlyuntil the print is clear.",
//     },
//     {
//       theme:
//         "If the above steps are to exclude the problem has not been solved, please contact our customer service staff.",
//     },
//   ],
// },
// {
//   title: "6. How to convert between thermal and thermal transfer modes?",
//   details: [
//     {
//       theme:
//         "When you use the thermal mode, please make sure that there is no ribbon installed in the machine, if there is label paper and ribbon installed in the machine, it will be automatically recognized as thermal transfer mode, if you want to change to the thermal mode, you need to remove the ribbon and restart the printer.",
//     },
//   ],
// },
// {
//   title: "7. Why does paper skipping occur when printing?",
//   details: [
//     {
//       theme:
//         "1. Label size is set incorrectly, you need to ensure that the computer and software size settings are consistent.",
//     },
//     {
//       theme:
//         "2. Replacement of the new size of the label needs to be recalibrated（long press three seconds）.",
//     },
//     {
//       theme:
//         "3. Label sensor is covered by dust caused by incorrect detection, nees to cleaning.",
//     },
//     {
//       theme:
//         "If the above steps are to exclude the problem has not been resolved, please contact our customer service staff.",
//     },
//     {
//       theme: "Translated with www.DeepL.com/Translator (free version)",
//     },
//   ],
// },
// ];

//2023-11-1替换FAQ内容
const faqDataApp = [
  {
    title: "1. Printing aborted, indicator light is flashing red.",
    details: [
      {
        theme:
          "1) After replacing the paper with a different size, the printer is not detecting the current paper size.",
        children: [
          {
            text: 'Carry out the paper calibration operation as follows:'
          }, {
            text: '1.Cancel the current printer job on your computer or mobile phone.'
          }, {
            text: '2.Turn off the printer and restart, in the printer standby state (blue light),press and hold the paper feed button for about 3 seconds until the purple light appears,Release the paper feed button, and the printer automatically paper correction.'
          }, {
            text: '3.Observe the paper outlet, the following state shows that the paper calibration is successful:',
          }, {
            text: '- Gap paper: the paper stays in the gap position.',
            imgs: [require("@/assets/guide_1_1_1.jpg"), require("@/assets/guide_1_1_2.jpg")],
          }, {
            text: '- Continuous paper: the paper stops after a period of walking.'
          }, {
            text: '- Black mark paper: paper stays at the black mark centre line position.',
            imgs: [require("@/assets/guide_1_1_3.jpg")],
          }
        ],
      }, {
        theme:
          "2) Out of paper.",
        children: [
          {
            text: 'The paper needs to be replaced as follows:'
          }, {
            text: '1.Cancel the current printer job on your computer or mobile phone.'
          }, {
            text: '2.Replace the new paper roll.'
          }, {
            text: '3.Turn off the printer and restart it. Press the paper feed button once to have the printer print out one sheet of paper.',
          }, {
            text: 'Note: If you are installing a new paper roll with different size, you need to perform a paper calibration operation after installation.',
          },
        ],
      }, {
        theme:
          "3) Ribbon exhaustion (a silver page on the ribbon indicates that the ribbon is exhausted).",
        children: [
          {
            text: 'Please replace the ribbon as follows:'
          }, {
            text: '1.Cancel the current printer job on your computer or mobile phone.'
          }, {
            text: '2.Replace the ribbon with a new one.'
          }, {
            text: '3.Turn off the printer and restart it.',
          },
        ],
      }, {
        theme:
          "4) Paper type/size/gap settings do not match actual paper.",
        children: [
          {
            text: 'Printing PDF/images directly: '
          }, {
            text: 'Please check and set the correct paper type, size, gap or black mark height value on the driver (continuous paper does not need to be set).'
          }, {
            text: 'Printing with editing software: Please check and set the correct paper type, size, gap or black mark height value on the editing software (continuous paper does not need to be set).'
          }, {
            text: 'Note: When using black mark paper or continuous paper, be sure to check that the paper types correspond.',
          },
        ],
      }, {
        theme:
          "5) Gap sensor is stuck with a label.",
        children: [
          {
            text: 'Cancel the current printer job on your computer or mobile phone,check if there is a label stuck on the gap sensor, and remove any labels that are stuck on it, turn off the printer and restart it.'
          },
        ],
      },
    ],
  },

  {
    title: "2. Ribbon follows paper when printing.",
    img: require("@/assets/guide_2_0.jpg"),
    details: [
      {
        theme:
          "Printer is currently in thermal mode and the ribbon recycling function is disabled.",
        children: [
          {
            text: 'If using thermal transfer mode:'
          }, {
            text: '1. Restart the printer, the ribbon will tighten automatically. (If there is any remaining untightened ribbon, please turn off the printer again and restart it.)'
          }, {
            text: '2. In the driver -> Options, set the print method to "Thermal Transfer".'
          }, {
            text: 'Note: If it is a mobile phone Bluetooth connection, just perform step 1.',
            isWrap: true,//是否有换行
          }, {
            text: 'If using thermal mode:'
          }, {
            text: '1. Remove the ribbon and restart the printer.'
          }, {
            text: '2. In Driver->Options, set the print mode to "Thermal".'
          }, {
            text: 'Note: If the mobile phone is connected by Bluetooth, perform step 1.'
          }
        ],
      }
    ],
  },

  {
    title: "3. Blank or incomplete printouts.",
    details: [
      {
        theme:
          "1) Print head not covered tightly.",
        children: [
          {
            text: 'Press the “Push” button and the printer automatically lifts the print head, presses down on both sides of the catch and re-covers it until makes two “clicks”.',
            imgs: [require("@/assets/guide_3_1_1.jpg")],
          }
        ],
      }, {
        theme:
          "2) Print head is jammed by a foreign object.",
        children: [
          {
            text: 'Clean the print head as follows:'
          }, {
            text: 'Open the top cover of the printer, press the “push” button, and use a cotton swab or non-woven cloth soaked in alcohol to wipe the print head.',
            imgs: [require("@/assets/guide_3_2_1.jpg")],
          }
        ],
      }, {
        theme:
          "3) Paper not printed face up.",
        children: [
          {
            text: 'Reinstall the paper roll, making sure the print side is facing up.'
          },
        ],
      }, {
        theme:
          "4) Power adapter power mismatch.",
        children: [
          {
            text: 'Please use the official power adapter, or a power adapter with an output power of 24v=2.5A.'
          },
        ],
      },
    ],
  },

  {
    title: "4. Printed content has irregular white streaks or white dots.",
    details: [
      {
        theme:
          "Dust on the print head or adhesive on the ribbon.",
        children: [
          {
            text: 'Clean the print head as follows:',
          }, {
            text: 'Open the top cover of the printer, press the “push” button, and use a cotton swab or non-woven cloth soaked in alcohol to wipe the print head.',
          }
        ],
      }
    ],
  },

  {
    title: "5. During printing, the second printout appears blank.",
    img: require("@/assets/guide_5_0.jpg"),
    details: [
      {
        theme:
          "Paper jam slot is too tight, the paper is squeezed unevenly, and the printer fails to recognise the paper correctly.",
        children: [
          {
            text: 'Open the printer and press the “push” button to adjust the distance of the paper slot to make sure the paper is flat.',
          }, {
            text: 'Note: A small gap can be left between the paper and the paper slot.',
          }
        ],
      }
    ],
  },

  {
    title: "6. Printed output appears to have a light color tone.",
    details: [
      {
        theme:
          "Print speed is too high and the print concentration is too low.",
        children: [
          {
            text: 'Please set the appropriate print, print concentration(adjust to high) and print speed (adjust to low) on the driver.',
          }, {
            text: 'Recommended : print speed 4, print concentration 8.',
          }
        ],
      }
    ],
  },

  {
    title: "7. After connecting the printer to the computer, it will automatically print continuously.",
    details: [
      {
        theme:
          "If there are any pending print jobs on the computer, the printer will automatically resume and continue executing those print tasks upon connection.",
        children: [
          {
            text: 'Please check and cancel any print jobs on the computer.',
          }
        ],
      }
    ],
  },

  {
    title: "8. After clicking “Print”, the printer does not respond.",
    details: [
      {
        theme:
          "Printer is not connected to the computer in USB connection mode.(USB cable is loose)",
        children: [
          {
            text: 'Please check “Control Panel - Devices and Printers” to see if there is a “T310printer”printer icon, re-plug the USB cable until the icon appears, and the icon lights up.',
          }
        ],
      },
      {
        theme:
          "Printer is occupied by other devices connected in Bluetooth connection.",
        children: [
          {
            text: 'Check if Bluetooth is disconnected and reconnect Bluetooth.',
          }
        ],
      },
      {
        theme:
          "The print job has been paused on the computer.",
        children: [
          {
            text: 'Please check and release the “paused”print job on your computer.',
          }
        ],
      }
    ],
  },

  {
    title: "9. PC connects to Bluetooth, can't find the printer.",
    details: [
      {
        theme:
          "Bluetooth function of the printer does not work.",
        children: [
          {
            text: 'Please follow the steps below to eliminate:',
          }, {
            text: '1.double-click the “paper feed" button , the printer automatically prints the self-test page, check whether there is Bluetooth address information on the self-test page, no means that the Bluetooth function is not in effect.',
          }, {
            text: 'Please contact customer service to obtain the instructional video, or scan the QR code to view it.',
          }, {
            text: '2.turn off the printer, open the cover at the bottom of the printer, re-plug the Bluetooth electronic board.',
          },
        ],
      },
      {
        theme:
          "Does not support the computer system Bluetooth direct connection, need to be connected through the software “labelife” APP.",
        children: [
          {
            text: 'Download and install the “labelife” APP, and connect to the Bluetooth connection portal on the labelife editing interface.',
            imgs: [require("@/assets/guide_9_1_1.jpg")],
          }
        ],
      },
    ],
  },
];

const tattooFaq = [
  {
    title: "1. Are there any other uses for M08F Tattoo Stencil Printer?",
    details: [
      {
        theme: "Yes, in addition to tattoos, Phomemo tattoo stencil printer can be used to print normal a4 thermal paper.",
      },
    ],
  },
  {
    title: "2. After I print out the pattern, how to transfer it onto skin?",
    details: [
      {
        theme:
          "1.Prior to transferring, it is necessary to clean the skin by wiping it with alcohol to eliminate any oils.",
      }, {
        theme:
          "2.Gently apply the transfer tattoo paste or deodorant onto the skin.",
      }, {
        theme:
          "3.Press the back side of the pattern firmly against the skin for at least 3 seconds before removing the paper.",
      }, {
        theme:
          "4.Allow the stenciled skin to dry for a period of 10-15 minutes.",
      },
    ],
  },
  {
    title: "3. Do I need to replace the ink or ribbon regularly?",
    details: [
      {
        theme:
          "No. M08F Tattoo Printer with thermal printing technology does not require additional consumables such as ink and ribbon.",
      },
    ],
  },
  {
    title: "4. What is the difference between this printer and Phomemo M08f A4 Portable Thermal Printer?",
    details: [
      {
        // theme: 'Since the M08F is an A4 thermal printer, it can only print on A4 size thermal paper. (You can find compatible thermal paper in our store)',
        theme:
          "Compared to the Phomemo M08f A4 Portable Printer, this tattoo printer is optimized specifically for tattoo printing. We have improved the printer's algorithms for better rendering of clear tattoo patterns. The complimentary paper is also different.",
      },
    ],
  },
  {
    title: "5. Can't connect my phone with Bluetooth, what should I do?",
    details: [
      {
        theme:
          "1. Please make sure that the Bluetooth on the drop-down page is turned on and then connect the printer in the “Phomemo” APP.",
      }, {
        theme:
          "2. Please make sure that all permissions were allowed when installing the app or you can turn them on in the Settings of the phone.",
      }, {
        theme:
          "3. Please try restarting the printer and phone.",
      }, {
        theme:
          "4. Please try to reinstall Phomemo App or download Phomemo on another mobile phone to see if it can connect to the printer.",
      }, {
        theme:
          "If that still doesn't work, please use thermal paper, double-click to print the QR code, and then scan the QR code in our APP to connect.",
        hasBr: true,
      }, {
        theme:
          "If it still does not work, please provide us with the information below to check.",
      }, {
        theme:
          "1. The model and system version of your phone.",
      }, {
        theme:
          "2. The APP version.",
      },
    ],
  },
  {
    title: "6. What file formats can be printed?",
    details: [
      {
        theme:
          "Please note that M08F tattoo stencil printer can print common document and picture formats, such as WORD, TXT, PDF, JPG, etc. It also supports printing web content.",
      },
    ],
  },
  {
    title:
      "7. Is the M08F printer connected to a computer wirelessly via Bluetooth?",
    details: [
      {
        theme:
          "Please note that M08F tattoo printer can only be connected to a computer with a data cable. And before using it for the first time, please download and install the driver in the computer, otherwise it will not be able to connect normally.",
      },
    ],
  },
  {
    title: "8. Why did the computer fail to connect to the M08F printer?",
    details: [
      {
        theme:
          "1. Please check whether the USB cable is connected to the M08F printer and the computer.",
      },
      {
        theme:
          "2. Please check whether the latest version of the driver is installed on your computer (please find the download and installation method of the driver at the top of this page).",
      },
      {
        theme:
          "3. If there is no problem in the above two steps, please restart the computer and try again, or contact our customer service to help you solve the problem.",
      },
    ],
  },
  {
    title:
      "9. I have installed the driver, but the printer still won't connect to the computer. How can I solve the problem?",
    details: [
      {
        theme:
          "If you are using Windows, ensure that you have downloaded the driver with the suffix (x64) and not (ARM). Windows and ARM versions are not compatible.",
      }, {
        theme:
          "Please refer to the computer driver installation guide on our APP “Phomemo” homepage and download the latest driver from our official website. Install the relevant driver according to your operating system version by following the instructions provided.",
      }, {
        theme:
          "If the problem cannot be solved, please send videos or pictures of the situation to our customer service so that we can better understand it and provide you with a more effective solution.",
      },
    ],
  },
  {
    title: "10. The printer doesn't recognize the paper, what do I have to do to fix it?",
    details: [
      {
        theme:
          "1. Turn on the printer and do not put any paper.",
      }, {
        theme:
          "2. Long press the power button for 10-20 seconds until the printer's light flashes twice, and then release the power button to complete the learning label.",
      }, {
        theme:
          "3. Long press the power button to turn it on and reload the paper to print .",
        hasBr: true,
      }, {
        theme:
          "If the problem still cannot be solved, please provide our customer service with the following information:",
      }, {
        theme:
          "A. Please provide me with some problem videos so that I can know what is wrong with your printer. (You can find our official eamil address in product manual.)",
      }, {
        theme:
          "B. Please provide the SN code of your printer.",
      },
    ],
  },
  {
    title: "11. The printer has a paper jam, what do I have to do to fix it?",
    details: [
      {
        theme:
          "1. Ensure that the paper is installed correctly. Pull the paper to the correct position and close the paper bin.",
      },
      {
        theme:
          "2. If the paper is installed correctly, double-click the power button to print out a QR code and check if it prints normally.",
      }, {
        theme:
          "3. Make sure the printer has enough power. If it is below 20%, charge it for approximately 2 hours before attempting to print again.",
      }, {
        theme:
          "4. Check the print head, rubber roller, and paper outlet for any dirt or debris. Use a 5.cotton swab dipped in alcohol to clean them.",
      }, {
        theme:
          "Try using thermal paper instead of tattoo paper to see if it can print normally.",
      }, {
        theme:
          "5. Verify the firmware version of your printer. An outdated firmware version may cause paper jams. Please send a screenshot of the firmware version to our customer service, and we will assist you in updating it.",
      },
    ],
  },
  {
    title:
      "12. The printout is not clear, what do I have to do?",
    details: [
      {
        theme:
          "1. Please increase the print density in the APP.",
      }, {
        theme:
          "2. Please try to clean the print head. Wipe the cutting part of the printer, especially the black line, with alcohol cotton to ensure no dirt on the print head.",
      }, {
        theme:
          "3.Most of the poor printing results are printed with low quality source files. Please try to print the template in the APP and send a photo of the printed template for us to check.",
      }, {
        theme:
          "4. Try to replace another roll of paper for printing. It may be damp and affect the printing quality.",
      }, {
        theme:
          "5.Please check the battery of the printer, If it is less than 10%, please charge it in time.",
        hasBr: true,
      }, {
        theme:
          "If none of the above methods solves the problem, please contact our customer service team.",
      },
    ],
  },
];

//新版-M832数据
const m832Info = {
  topImgs: [
    { name: '', url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832_img1.png' },
    { name: '', url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832_img2.png' },
    { name: '', url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832_img3.jpg' },
    { name: '', url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832_img4.jpg' },
    { name: '', url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832_img5.jpg' },
  ],
  videoList: [
    {
      title: "1.How to use on Windows",
      videoUrl:
        // "https://oss.qu-in.top/printerFiles/phomemo/M832/1.How to use on Windows.mp4",
        "https://oss.qu-in.top/printerFiles/phomemo/M832/832-windows英.mp4",
      type: "PC",
      recordKey: 'M832_windowsVideo',
    },
    {
      title: "2.How to use on macOS",
      videoUrl:
        "https://oss.qu-in.top/printerFiles/phomemo/M832/How_to_use_on_macOS.mp4",
      type: "PC",
      recordKey: 'M832_macVideo',
    },
    {
      title: "3.How to use on Linux",
      videoUrl:
        "https://oss.qu-in.top/printerFiles/phomemo/M832/3.How to use on Linux.mp4",
      type: "PC",
      recordKey: 'M832_linuxVideo',
    },
    {
      title: "4.How to use on IOS Or Android",
      videoUrl:
        "https://oss.qu-in.top/printerFiles/phomemo/M832/How_to_use_on IOSOrAndroid.mp4",
      type: "PC",
      recordKey: 'M832_APPVideo',
    },
    {
      title: "5.How to use on ChromeOS",
      videoUrl:
        "https://oss.qu-in.top/printerFiles/phomemo/M832/M832-ChromeVideo.mp4",
      poster: 'https://oss.qu-in.top/printerFiles/phomemo/M832/m832ChromeVideoPoster.png',
      type: "PC",
      recordKey: 'M832_ChromeOSVideo',//尚未给出标识字符
    },
  ],
  driverList: [
    {
      title: 'M832 Series APP Installer (Android & iOS)',
      url: 'https://downloadapp.qu-in.life/MrIn-Phomemo/',
      desp: 'OPERATING SYSTEM: Android 7 and above, iOS 13 and above',
      version: '',
      key: 1,
      recordKey: 'M832_AppStore'
    },
    {
      title: 'M832 series Driver setup package (Windows & Windows ARM)',
      url: 'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Win.zip',
      desp: 'OPERATING SYSTEM: Windows 7 （32 bit, 64 bit）, 8（32 bit, 64 bit）, 10（32 bit, 64 bit）, 11 (64 bit) , ARM',
      version: '(Version：QY_Printer_Driver_Win.zip)',
      key: 2,
      recordKey: 'M832_windowsDrivers'
    },
    // {
    //   title: 'M832 series Driver setup package (WindowsARM)',
    //   url: 'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Win.zip',
    //   desp: 'OPERATING SYSTEM: ARM',
    //   version: '(Version：QY_Printer_Driver_Win.zip)',
    //   key: 3,
    //   recordKey: 'M832_ARMDrivers'
    // },
    {
      title: 'M832 series Driver setup package (macOS)',
      url: 'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Mac.zip',
      desp: 'OPERATING SYSTEM: macOS 10.14 (Mojave) and above',
      version: '(Version：QY_Printer_Driver_Mac.zip)',
      key: 4,
      recordKey: 'M832_macDrivers'
    },
    {
      title: 'M832 series Driver setup package (Linux)',
      // url: 'https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%C2%A0Driver_Linux.gz',
      url: 'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Linux.zip',
      desp: 'OPERATING SYSTEM: Ubuntu Centos7',
      version: '(Version：QY_Printer_Driver_Linux)',
      key: 5,
      recordKey: 'M832_linuxDrivers'
    },
    {
      title: 'M832 series Driver setup package (Chrome OS)',
      url: 'https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%C2%A0Driver_ChromeOS.zip',
      desp: 'OPERATING SYSTEM: -',
      // version: '(Version：-)',
      key: 6,
      recordKey: 'M832_chromeOSDrivers', //尚未给出标识字符
    },
    {
      title: 'Download Extraction Tool',
      url: 'https://www.win-rar.com/download.html?&L=0',
      desp: 'Unzip Your Driver Files for Installation',
      // version: '(Version：-)',
      key: 7,
      recordKey: 'M832_Download_Extraction_Tool', //尚未给出标识字符
      btnText: 'GET  TOOL'
    }
  ],
  guidesList: [
    {
      title: 'EN',
      // url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832 英文 中性详细说明书-长版-修1-20230919-转曲.pdf',
      url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832-English.pdf',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/gb.svg',
      key: 1
    },
    {
      title: 'JA',
      url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832 日文 中性详细说明书-长版-20230913-转曲.pdf',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/jp.svg',
      key: 2
    },
    {
      title: 'DE',
      url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832 德文 中性详细说明书-长版-20230913-转曲.pdf',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/de.svg',
      key: 3
    },
    {
      title: 'FR',
      url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832 法文 中性详细说明书-长版-20230913-转曲.pdf',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/fr.svg',
      key: 4
    },
    {
      title: 'IT',
      url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832 意文 中性详细说明书-长版-20230914-转曲.pdf',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/it.svg',
      key: 5
    },
    // {
    //   title: 'ES',
    //   url: 'https://oss.qu-in.top/printerFiles/phomemo/M832/M832 意文 中性详细说明书-长版-20230914-转曲.pdf',
    //   iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/es.svg',
    //   key: 6
    // },
  ],

  faqData: [
    {
      title: "1. Unclear printing?",
      details: [
        {
          theme: "(1) Please update the printer firmware to the latest version in the mobile app phomemo.",
        },
        {
          theme: "(2) Insufficient battery power can affect printing quality. Please check the battery level of the printer. If it is below 30%, please charge it for 2-3 hours before printing.",
        },
        {
          theme: "(2) Turn on the printer and double-click the power button to print the self-test page to check the printer’s battery level.",
        },
        {
          theme: "(4) Adjust the print density in the app.",
        },
        {
          theme: "(5) Click on “Print” and adjust the print density in the print preview.",
        },
        {
          theme: "(6) Clean the print head.",
        },
        {
          theme: "(7) Use alcohol wipes to clean the cutting section of the printer, especially where there are black lines, to make sure there is no adhesive residue or foreign objects on the print head.",
        },
        {
          theme: "(8) Please replace a new paper roll printing. Moisture exposure of the paper roll will affect the print quality. Please store the paper roll sealed in a dark, cool, and dry environment.",
        },
        {
          theme: "(9) If the above steps do not solve your problem, please send us the original image and a photo of the printout for troubleshooting. At the same time, please provide with us your order number, purchase date, and purchase platform.",
        },
      ],
    }, {
      title: "2. What kind of paper does this printer work with?",
      details: [
        {
          theme: "Phomemo M832 Thermal Printer Supports Folded, Sheet and Roll Thermal Paper. (Note: Cannot print on plain paper, the diameter of the thermal paper roll must not exceed 28mm).",
        },
      ]
    }, {
      title: "3. How to use a phone or tablet to connect to the printer and start printing?",
      details: [
        {
          theme: `Get the "Phomemo" app from Google Play or the Apple Store, turn on Bluetooth on your phone or tablet, then search for the M832 Portable Printer on the "Phomemo" app and connect then print.`,
        },
      ]
    }, {
      title: "4. How to use a desktop or laptop to connect to a printer and start printing?",
      details: [
        {
          theme: `Connect the printer to your computer using a USB cable, download the appropriate system driver from the Phomemo Driver website and install it, you can print after the driver is successfully installed.`,
        },
      ]
    }, {
      title: "5. What are some of the things you need to pay special attention to with printers?",
      details: [
        {
          theme: `1. Phone or tablet cannot directly use Bluetooth connection and need to be connected through the Phomemo application in order to use it.`,
        },
        {
          theme: `2. Desktop or laptop can only connect to the printer via USB cable, not via Bluetooth.`,
        },
      ]
    }, {
      title: "6. What this printer has to offer?",
      details: [
        {
          theme: `Phomemo M832 Portable Printer only prints on thermal paper and has no scanning or copying capabilities.`,
        },
      ]
    }, {
      title: "7. Charging abnormality?",
      details: [
        {
          theme: "(1) Please make sure that the power socket is live, and the charging cable and the charging head with an output voltage of 5V-2A can work normally.",
        },
        {
          theme: "(2) You may use other electrical devices to see if the power socket, the charging cable and charging head can work normally.",
        },
        {
          theme: "(3) Reconfirm that the output voltage of the charging head in use is 5V-2A. Fast chargers with output voltage exceeding 5V may damage the printer.",
        },
        {
          theme: "(4) Make sure that one end of the charging cable is fully inserted into the printer and the other end is fully inserted into the charging head. Ensure the charging head is fully plugged into the power socket.",
        },
        {
          theme: "(5) The printer will flash during charging. When the printer is fully charged the indicator light will stop flashing. Typically, it takes 2-3 hours to fully charge the printer. Then please turn the printer on again.",
        },
        {
          theme: "(6) If the above do not solve your problem, please provide us with your order number and purchase date, and also send us a video showing the problem encountered when charging.",
        },
      ]
    }, {
      title: "8. Do I need to replace the ink or ribbon regularly?",
      details: [
        {
          theme: `The M832 printer with thermal printing technology does not require additional consumables such as ink and ribbon.`
        },
      ]
    }, {
      title: "9. What file formats can be printed?",
      details: [
        {
          theme: `The M832 printer can print common document and picture formats, such as WORD, TXT, PDF, JPG, etc. It also supports printing web content.`
        },
      ]
    }, {
      title: "10. Why does the M832 printer print blank paper?",
      details: [
        {
          theme: `Firstly, please check whether the printing paper you are using is thermal paper. Regular paper cannot be printed with a thermal printer. (You can find compatible thermal paper in our store)`
        }, {
          theme: "Secondly, if you are using the thermal paper we provide, please check if you have reversed the front and back. Please follow the instructions marked on the printing paper to feed the paper in the correct direction.",
        }, {
          theme: "Finally, please check if the printer is about to run out of power and charge it in time."
        },
      ]
    },
  ],
  alsoLikeArr: [
    { title: "4 Rolls 8.5'' x 11'' Phomemo M832 Portable Printer Thermal Paper", productUrl: 'https://www.amazon.com/dp/B0CJHNQRFY/ref=emc_bcc_2_i?th=1', img: 'https://m.media-amazon.com/images/I/61uTc3yfzPL.__AC_SX300_SY300_QL70_FMwebp_.jpg' },
    { title: '4 Rolls Phomemo M832 Portable Printer A4 Thermal Paper', productUrl: 'https://www.amazon.com/dp/B0CJHMBJ6Q/ref=emc_bcc_2_i?th=1', img: 'https://m.media-amazon.com/images/I/61H44BbHLkL.__AC_SX300_SY300_QL70_FMwebp_.jpg' },
    { title: '200 Sheets Phomemo M832 Portable Printer Thermal Paper A4 Thermal Paper', productUrl: 'https://www.amazon.com/dp/B0CJHQ2YK5/ref=emc_bcc_2_i?th=1', img: 'https://m.media-amazon.com/images/I/71wvOJr+nrL._AC_SY300_SX300_.jpg' },
    { title: '200 Sheets Phomemo M832 Portable Printer Thermal Paper Letter Size Thermal Paper Fold', productUrl: 'https://www.amazon.com/dp/B0CJHVKZ9Q/ref=emc_bcc_2_i?th=1', img: 'https://m.media-amazon.com/images/I/71jGKgKm4OL.__AC_SX300_SY300_QL70_FMwebp_.jpg' },
    { title: 'Phomemo Carrying Case, Compatible with M832 Portable Printer', productUrl: 'https://www.amazon.com/dp/B0CQX3H987/ref=emc_bcc_2_i', img: 'https://m.media-amazon.com/images/I/71Xm4hTCeyL._AC_SX466_.jpg', isLowerImg: true },
    { title: 'Phomemo M832 Portable Printer 53MM Thermal Paper Roll', productUrl: 'https://www.amazon.com/dp/B0CM9B1LMS/ref=emc_bcc_2_i?th=1', img: 'https://m.media-amazon.com/images/I/61irKpZhjgL.__AC_SX300_SY300_QL70_FMwebp_.jpg' },
    { title: 'Phomemo M832 Portable Printer 80MM Thermal Paper Roll', productUrl: 'https://www.amazon.com/dp/B0CM9B4F3L/ref=emc_bcc_2_i?th=1', img: 'https://m.media-amazon.com/images/I/61E7TQjEKwL.__AC_SX300_SY300_QL70_FMwebp_.jpg' },
    { title: 'Phomemo M832 Portable Printer 110MM Thermal Paper Roll', productUrl: 'https://www.amazon.com/dp/B0CM99NW4R/ref=emc_bcc_2_i?th=1', img: 'https://m.media-amazon.com/images/I/61pj7JOx74L.__AC_SX300_SY300_QL70_FMwebp_.jpg' },
  ]
};

const m833Info = {
  guidesList: [
    {
      title: 'EN',
      url: 'https://pages.phomemo.com/resources/M833-快速指南.pdf',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/gb.svg',
      key: 1
    },
    {
      title: 'JA',
      url: 'https://pages.phomemo.com/resources/M833-快速指南.pdf',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/jp.svg',
      key: 2
    },
    {
      title: 'DE',
      url: 'https://pages.phomemo.com/resources/M833-快速指南.pdf',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/de.svg',
      key: 3
    },
    // {
    //   title: 'FR',
    //   url: 'https://pages.phomemo.com/resources/M833-快速指南.pdf',
    //   iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/fr.svg',
    //   key: 4
    // },
    // {
    //   title: 'IT',
    //   url: 'https://pages.phomemo.com/resources/M833-快速指南.pdf',
    //   iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/it.svg',
    //   key: 5
    // },
  ],
  faqData: [
    {
      title: "1. Unclear printing?",
      details: [
        {
          theme: "(1) Please update the printer firmware to the latest version in the mobile app phomemo.",
        },
        {
          theme: "(2) Insufficient battery power can affect printing quality. Please check the battery level of the printer. If it is below 30%, please charge it for 2-3 hours before printing.",
        },
        {
          theme: "(2) Turn on the printer and double-click the power button to print the self-test page to check the printer’s battery level.",
        },
        {
          theme: "(4) Adjust the print density in the app.",
        },
        {
          theme: "(5) Click on “Print” and adjust the print density in the print preview.",
        },
        {
          theme: "(6) Clean the print head.",
        },
        {
          theme: "(7) Use alcohol wipes to clean the cutting section of the printer, especially where there are black lines, to make sure there is no adhesive residue or foreign objects on the print head.",
        },
        {
          theme: "(8) Please replace a new paper roll printing. Moisture exposure of the paper roll will affect the print quality. Please store the paper roll sealed in a dark, cool, and dry environment.",
        },
        {
          theme: "(9) If the above steps do not solve your problem, please send us the original image and a photo of the printout for troubleshooting. At the same time, please provide with us your order number, purchase date, and purchase platform.",
        },
      ],
    }, {
      title: "2. What kind of paper does this printer work with?",
      details: [
        {
          theme: "Phomemo M833 Thermal Printer Supports Folded, Sheet and Roll Thermal Paper. (Note: Cannot print on plain paper, the diameter of the thermal paper roll must not exceed 28mm).",
        },
      ]
    }, {
      title: "3. How to use a phone or tablet to connect to the printer and start printing?",
      details: [
        {
          theme: `Get the "Phomemo" app from Google Play or the Apple Store, turn on Bluetooth on your phone or tablet, then search for the M833 Portable Printer on the "Phomemo" app and connect then print.`,
        },
      ]
    }, {
      title: "4. How to use a desktop or laptop to connect to a printer and start printing?",
      details: [
        {
          theme: `Connect the printer to your computer using a USB cable, download the appropriate system driver from the Phomemo Driver website and install it, you can print after the driver is successfully installed.`,
        },
      ]
    }, {
      title: "5. What are some of the things you need to pay special attention to with printers?",
      details: [
        {
          theme: `1. Phone or tablet cannot directly use Bluetooth connection and need to be connected through the Phomemo application in order to use it.`,
        },
        {
          theme: `2. Desktop or laptop can only connect to the printer via USB cable, not via Bluetooth.`,
        },
      ]
    }, {
      title: "6. What this printer has to offer?",
      details: [
        {
          theme: `Phomemo M833 Portable Printer only prints on thermal paper and has no scanning or copying capabilities.`,
        },
      ]
    }, {
      title: "7. Charging abnormality?",
      details: [
        {
          theme: "(1) Please make sure that the power socket is live, and the charging cable and the charging head with an output voltage of 5V-2A can work normally.",
        },
        {
          theme: "(2) You may use other electrical devices to see if the power socket, the charging cable and charging head can work normally.",
        },
        {
          theme: "(3) Reconfirm that the output voltage of the charging head in use is 5V-2A. Fast chargers with output voltage exceeding 5V may damage the printer.",
        },
        {
          theme: "(4) Make sure that one end of the charging cable is fully inserted into the printer and the other end is fully inserted into the charging head. Ensure the charging head is fully plugged into the power socket.",
        },
        {
          theme: "(5) The printer will flash during charging. When the printer is fully charged the indicator light will stop flashing. Typically, it takes 2-3 hours to fully charge the printer. Then please turn the printer on again.",
        },
        {
          theme: "(6) If the above do not solve your problem, please provide us with your order number and purchase date, and also send us a video showing the problem encountered when charging.",
        },
      ]
    }, {
      title: "8. Do I need to replace the ink or ribbon regularly?",
      details: [
        {
          theme: `The M833 printer with thermal printing technology does not require additional consumables such as ink and ribbon.`
        },
      ]
    }, {
      title: "9. What file formats can be printed?",
      details: [
        {
          theme: `The M833 printer can print common document and picture formats, such as WORD, TXT, PDF, JPG, etc. It also supports printing web content.`
        },
      ]
    }, {
      title: "10. Why does the M833 printer print blank paper?",
      details: [
        {
          theme: `Firstly, please check whether the printing paper you are using is thermal paper. Regular paper cannot be printed with a thermal printer. (You can find compatible thermal paper in our store)`
        }, {
          theme: "Secondly, if you are using the thermal paper we provide, please check if you have reversed the front and back. Please follow the instructions marked on the printing paper to feed the paper in the correct direction.",
        }, {
          theme: "Finally, please check if the printer is about to run out of power and charge it in time."
        },
      ]
    },
  ],
  alsoLikeArr: [
    {
      site: 'US Paper',
      title: 'Phomemo US Letter Thermal Paper, Advanced Thermal Printing, Phomemo Thermal Printer Paper for M08F-Letter,M08F M832,M833 M834 M835 Portable Thermal Printer, Size 8.5"×11”, ...',
      allTitle: 'Phomemo US Letter Thermal Paper, Advanced Thermal Printing, Phomemo Thermal Printer Paper for M08F-Letter,M08F M832,M833 M834 M835 Portable Thermal Printer, Size 8.5"×11”, 200 Sheets',
      productUrl: 'https://www.amazon.com/gp/product/B0CR1MCRGQ',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_1.jpg'
    },
    {
      site: 'US Paper',
      title: 'Phomemo A4 Thermal Paper - White Quick-Dry Printer Paper, Multipurpose Thermal Paper Compatible for Phomemo M08F, M832, M833 Portable Thermal Printer and Brother PJ762 PJ763, ...',
      allTitle: 'Phomemo A4 Thermal Paper - White Quick-Dry Printer Paper, Multipurpose Thermal Paper Compatible for Phomemo M08F, M832, M833 Portable Thermal Printer and Brother PJ762 PJ763, 8.27"x11.69", 100 Sheets',
      productUrl: 'https://www.amazon.com/dp/B0CR1NPGX7',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_2.jpg'
    },
    {
      site: 'US Paper',
      title: 'US Letter Thermal Paper - 8.5” x 11” Quick-Dry Letter Paper, Compatible with Phomemo M08F-Letter M832 M831 M833 M834 M835 Q301 Q302 & Brother-Letter Thermal Printer for Documents ...',
      allTitle: 'US Letter Thermal Paper - 8.5” x 11” Quick-Dry Letter Paper, Compatible with Phomemo M08F-Letter M832 M831 M833 M834 M835 Q301 Q302 & Brother-Letter Thermal Printer for Documents Contracts, 100 Sheets',
      productUrl: 'https://www.amazon.com/dp/B0CRZ5KWM3',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_3.jpg'
    },
    {
      site: 'US Paper',
      title: 'Memoqueen Thermal Paper 8.5 x 11 White US Letter Thermal Printer Paper Compatible with M08F Letter, M832, M834, M835, MT800 Portable Printer, Quick-Dry Size 8.5" x 11" Business Paper ...',
      allTitle: 'Memoqueen Thermal Paper 8.5 x 11 White US Letter Thermal Printer Paper Compatible with M08F Letter, M832, M834, M835, MT800 Portable Printer, Quick-Dry Size 8.5" x 11" Business Paper Label, 100 Sheets',
      productUrl: 'https://www.amazon.com/dp/B0CQZWPNHY',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_4.png'
    },
    {
      site: 'US Paper',
      title: 'Phomemo A4 Quick-dry Continuous Thermal Paper, 8.27"x275 3/5" (210mm*6.5m) width, black text, 4 Rolls in box. Compatible with Phomemo M08F/M832/M833/M834 portable A4 printer. Storage...',
      allTitle: 'Phomemo A4 Quick-dry Continuous Thermal Paper, 8.27"x275 3/5" (210mm*6.5m) width, black text, 4 Rolls in box. Compatible with Phomemo M08F/M832/M833/M834 portable A4 printer. Storage for 10 years',
      productUrl: 'https://www.amazon.com/gp/product/B0CR1MFNK4',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_5.png'
    },


    {
      site: 'CA Paper',
      title: "Letter Thermal Paper 2 Rolls, Thermal Printer Paper Roll for Quick-Drying, Compatible with Phomemo M08F-Letter M832/M833 Portable Printer, Size 8.5’’ x 11’’, File Keep for 10 Years",
      allTitle: 'Letter Thermal Paper 2 Rolls, Thermal Printer Paper Roll for Quick-Drying, Compatible with Phomemo M08F-Letter M832/M833 Portable Printer, Size 8.5’’ x 11’’, File Keep for 10 Years',
      productUrl: 'https://www.amazon.ca/dp/B0CRL95HDN',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_1.png'
    },
    {
      site: 'CA Paper',
      title: `Letter Thermal Paper, White Fast-Drying Folding Thermal Paper, Advanced Thermal Printing, Compatible with Phomemo M08F, M832, M833, with Other Letter Portable Printer,Size 8.5" x 11",...`,
      allTitle: 'Letter Thermal Paper, White Fast-Drying Folding Thermal Paper, Advanced Thermal Printing, Compatible with Phomemo M08F, M832, M833, with Other Letter Portable Printer,Size 8.5" x 11",200 Sheets',
      productUrl: 'https://www.amazon.ca/dp/B0CRL84PVM',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_2.png'
    },
    {
      site: 'CA Paper',
      title: "Thermal Paper 8.5 x 11 Inch, Letter Thermal Printer Paper, Advance Thermal Printing for Quick-Dry, Compatible with M08F-Letter, M832/M833, MT800 Letter Portable Printer,200 Sheets",
      allTitle: 'Thermal Paper 8.5 x 11 Inch, Letter Thermal Printer Paper, Advance Thermal Printing for Quick-Dry, Compatible with M08F-Letter, M832/M833, MT800 Letter Portable Printer,200 Sheets',
      productUrl: 'https://www.amazon.ca/dp/B0CRL8HFKP',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_3.png'
    },
    {
      site: 'CA Paper',
      title: "Thermal Printer Paper, A4 Thermal Paper Roll for Quick-Dry, Advance Thermal Printing for A4 Portable Printer, Compatible with M08F M832 M833 Portable Printer,2 Rolls",
      allTitle: 'Thermal Printer Paper, A4 Thermal Paper Roll for Quick-Dry, Advance Thermal Printing for A4 Portable Printer, Compatible with M08F M832 M833 Portable Printer,2 Rolls',
      productUrl: 'https://www.amazon.ca/dp/B0CRL7PJTV',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_4.png'
    },
    {
      site: 'CA Paper',
      title: "Thermal Paper A4, Thermal Printer Paper for A4 Portable Printer, Advanced Thermal Printing Quick-Dry,Compatible with Phomemo M08F-A4, M832, M833, with Brother A4 Portable Printer, 200 Sheets",
      allTitle: 'Thermal Paper A4, Thermal Printer Paper for A4 Portable Printer, Advanced Thermal Printing Quick-Dry,Compatible with Phomemo M08F-A4, M832, M833, with Brother A4 Portable Printer, 200 Sheets',
      productUrl: 'https://www.amazon.ca/dp/B0CRL87VB9',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_5.png'
    },

    {
      site: 'UK Paper',
      title: 'Phomemo A4 Thermal Printer Paper, 210mm x 6.5m (8.27" x 256"), Compatible with Phomemo M08/M08F/M831/ M832/M833/M834 Portable A4 Printer, for Travel, Home, Office, Photos, Invoices, ...',
      allTitle: 'Phomemo A4 Thermal Printer Paper, 210mm x 6.5m (8.27" x 256"), Compatible with Phomemo M08/M08F/M831/M832/M833/M834 Portable A4 Printer, for Travel, Home, Office, Photos, Invoices, Contracts, 2 Rolls',
      productUrl: 'https://www.amazon.co.uk/dp/B0CR1BJ3L3?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_1.jpeg'
    },
    {
      site: 'UK Paper',
      title: 'Phomemo A4 Thermal Printer Paper - 210mm x 6.5m (8.27" x 256"), Compatible with Phomemo M08/M831/M832/ M833/M834 Portable A4 Printer, for Travel, Home, Office, Photos, Invoices, ...',
      allTitle: 'Phomemo A4 Thermal Printer Paper - 210mm x 6.5m (8.27" x 256"), Compatible with Phomemo M08/M831/M832/M833/M834 Portable A4 Printer, for Travel, Home, Office, Photos, Invoices, Contracts, 4 Rolls',
      productUrl: 'https://www.amazon.co.uk/dp/B0CR18WS6J?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_2.png'
    },
    {
      site: 'EU Paper',
      title: 'Phomemo A4 Thermal Printer Paper, 210 mm x 7 m (8.27 x 276 inches), BPA-Free, Compatible with Phomemo M831/M832/M833 Mobile A4 Printer, for Travel, Home, Office, Photos, Bills, ...',
      allTitle: 'Phomemo A4 Thermal Printer Paper, 210 mm x 7 m (8.27 x 276 inches), BPA-Free, Compatible with Phomemo M831/M832/M833 Mobile A4 Printer, for Travel, Home, Office, Photos, Bills, Contracts, Tattoo, ...',
      productUrl: 'https://www.amazon.de/dp/B0CR3QLF95?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_3.jpeg'
    }, {
      site: 'EU Paper',
      title: 'Phomemo A4 Thermal Printer Paper, 4 Rolls, 210 mm x 7 m (8.27 x 276 inches), BPA-Free, Compatible with Phomemo M831/M832/M833 Mobile A4 Printer, for Travel, Home, Office, Photos, Bills...',
      allTitle: 'Phomemo A4 Thermal Printer Paper, 4 Rolls, 210 mm x 7 m (8.27 x 276 inches), BPA-Free, Compatible with Phomemo M831/M832/M833 Mobile A4 Printer, for Travel, Home, Office, Photos, Bills, Contracts',
      productUrl: 'https://www.amazon.de/dp/B0CR41JGBQ?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_4.jpeg'
    }, {
      site: 'EU Paper',
      title: 'Phomemo A4 Continuous Folding Thermal Paper, 210 mm x 297 mm (8.27 x 11.69 inches), Compatible with Phomemo M831/M832/M833 Portable A4 Printer, for Business, Home, Photo,...',
      allTitle: 'Phomemo A4 Continuous Folding Thermal Paper, 210 mm x 297 mm (8.27 x 11.69 inches), Compatible with Phomemo M831/M832/M833 Portable A4 Printer, for Business, Home, Photo, Invoice, Contract, Tattoo',
      productUrl: 'https://www.amazon.de/dp/B0CR3PNP32?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_5.jpeg'
    },
  ]
};

//2024-6-24替换FAQ内容
const faqDataAppForT310 = [
  {
    title: "1. Indicator light is flashing red.",
    details: [
      {
        theme:
          "1) Without performing paper calibration after switching to a different paper size, the printer failed to register the current dimensions.",
        children: [
          {
            text: 'Turn off the printer and restart it. When the printer indicator light turns solid blue, press and hold the paper feed button for about 3 seconds. The printer will automatically perform paper calibration.'
          },
        ],
      }, {
        theme:
          "2) Paper or ribbon is depleted.",
        children: [
          {
            text: 'Turn off the printer and restart it before replacing the paper roll/ribbon.'
          }
        ],
      }, {
        theme:
          "3) The paper type setting does not match the actual paper.",
        children: [
          {
            text: 'Turn off the printer and  restart it. Then, ensure that the paper type settings in the driver or editing software match the actual paper.',
            videos: [
              {
                url: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频0.mp4',
                poster: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频0-5共用封面.png'
              }
            ]
          }
        ],
      }, {
        theme:
          "4) The label is stuck on the gap sensor.",
        children: [
          {
            text: 'Check and remove the label stuck on the gap sensor. Turn off the printer and restart it.',
            imgs: ['https://oss.qu-in.top/printerFiles/phomemo/t310/img1-senor.png'],
          }
        ],
      }, {
        theme:
          "5) For double-row or multi-row labels, if the gap sensor is not positioned above the label, it may result in incorrect paper calibration.",
        children: [
          {
            text: 'Turn off the printer and restart it. Position the gap sensor above the label and initiate paper calibration again.',
            videos: [
              {
                url: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频1.mp4',
                poster: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频0-5共用封面.png'
              }
            ]
          },
        ],
      }, {
        theme:
          "6) Paper calibration error occurs when holes in the perforated paper are not aligned with the gap sensor.",
        children: [
          {
            text: 'Turn off the printer and restart it. Align the holes on the perforated paper with the gap sensor before restarting paper calibration.',
            videos: [
              {
                url: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频2.mp4',
                poster: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频0-5共用封面.png'
              }
            ]
          },
        ],
      },
    ],
  },
  {
    title: "2. The ribbon is running along with the paper during printing.",
    details: [
      {
        theme: "The machine is configured in thermal mode, with the default ribbon retraction function turned off.",
        children: [
          {
            text: '1. For Thermal Transfer Printing:'
          }, {
            text: '1) Restart the printer and the ribbon will automatically tighten. (If there is any remaining untightened ribbon, restart the printer multiple times until it is fully tightened).'
          }, {
            text: '2) Set the printing mode to "Thermal Transfer" in Driver -> Options.'
          }, {
            text: 'Note: When using Bluetooth connection from a mobile phone, only follow step 1.',
            isWrap: true,
          }, {
            text: '2. For Direct Thermal Printing:'
          }, {
            text: '1) Remove the ribbon, turn off the printer, and restart it.'
          }, {
            text: '2) Set the printing mode to "Direct Thermal" in Driver -> Options.'
          }, {
            text: 'Note: When using Bluetooth connection from a mobile phone, only follow step 1.',
            videos: [
              {
                url: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频3.mp4',
                poster: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频0-5共用封面.png'
              }
            ]
          },
        ],
      },
    ]
  },

  {
    title: "3. Blank or incomplete printouts",
    details: [
      {
        theme: "1) The print head is loose.",
        children: [
          {
            text: 'Open the top cover and press the Push button to elevate the print head automatically. Re-close it firmly. Apply slight pressure on both sides to firmly lock the clasps until you hear clicks on both sides.',
            imgs: ['https://oss.qu-in.top/printerFiles/phomemo/t310/img2-loose.png'],
          },
        ],
      }, {
        theme: "2) The paper type/size/gap settings are inconsistent with the actual paper.",
        children: [
          {
            text: 'Open the top cover and press the Push button to elevate the print head automatically. Re-close it firmly. Apply slight pressure on both sides to firmly lock the clasps until you hear clicks on both sides.',
            videos: [
              {
                url: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频4.mp4',
                poster: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频0-5共用封面.png'
              }
            ]
          },
        ],
      }, {
        theme: "3) The paper is not loaded with the printing side facing up.",
        children: [
          {
            text: 'Reinstall the paper roll to ensure that the print side is facing up.',
          },
        ],
      }, {
        theme: "4) Foreign substances stuck to the print head.",
        children: [
          {
            text: 'Use an alcohol-soaked cotton swab or non-woven cloth to clean the print head.',
            imgs: ['https://oss.qu-in.top/printerFiles/phomemo/t310/img3-excessive.png'],
          },
        ],
      },
    ]
  },
  {
    title: "4. The printed content is offset/misaligned.",
    details: [
      {
        theme: "Paper handling error.",
        children: [
          {
            text: 'Adjust the offset value in Driver.',
            videos: [
              {
                url: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频5.mp4',
                poster: 'https://oss.qu-in.top/printerFiles/phomemo/t310/视频0-5共用封面.png'
              }
            ]
          },
        ],
      }
    ],
  },
  {
    title: "5. Print appears lighter.",
    details: [
      {
        theme: "The printing speed is set too high, and density too low.",
        children: [
          {
            text: 'Adjust print density upwards and print speed downwards. Recommended settings: Print speed 4, print density 8.',
          },
        ],
      }
    ],
  },
  {
    title: "6. Paper skipping during printing.",
    details: [
      {
        theme: "Excessive tightness in the paper feed slot causes uneven pressure on the paper, preventing the printer from properly detecting the paper.",
        children: [
          {
            text: 'Re-adjust the paper feed slot to ensure that the paper is flat.',
          }, {
            text: 'Note: A slight opening may exist between the paper and paper feed slot.',
            imgs: ['https://oss.qu-in.top/printerFiles/phomemo/t310/img4.png'],
          },
        ],
      }
    ],
  },
  {
    title: "7. Automatic continuous paper feeding upon connection to computer.",
    details: [
      {
        theme: "The printer resumes any pending print tasks by default when connected to the computer.",
        children: [
          {
            text: 'Press the paper feed button to pause printing and cancel the print tasks.',
          },
        ],
      }
    ],
  },
  {
    title: "8. After clicking Print, the printer does not respond.",
    details: [
      {
        theme: "Under Bluetooth connection mode, the printer is occupied by someone else.",
        children: [
          {
            text: 'Check if the Bluetooth connection is disconnected and reconnect Bluetooth.',
          },
        ],
      }
    ],
  },
  {
    title: "9. Unable to find the printer when connecting to computer via Bluetooth.",
    details: [
      {
        theme: "Does not support direct Bluetooth connection to the computer. Connection via Labelife, an editing app, is needed.",
        children: [
          {
            text: 'Download and install Labelife, and connect via Bluetooth on the Labelife editing interface.',
          },
        ],
      }
    ],
  },
];

const tp86Info = {
  // faqData: [
  //   {
  //     title: "1. Power Indicator.",
  //     details: [
  //       {
  //         theme:
  //           "Lit (Green)：Normal",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Blinking (Green)：Charging",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Lit (Red)：Out of paper/ Cover is open/ Overhea",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Blinking (Red)：Low power",
  //         imgUrls: [],
  //       },
  //     ],
  //   }, {
  //     title: "2. Product use sequence.",
  //     details: [
  //       {
  //         theme:
  //           "Step 1: get the new Printer;",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           'Step 2: go to the app store or Google play to search for "phomemo";',
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Step 3: Download and install app;",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Step 4: turn on Bluetooth;",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Step 5: open the app and log in;",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Step 6: long press the equipment startup key to start the M08F (the shutdown method is the same);",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Step 7: click in the upper right corner of the app main interface to enter the printer connection interface and connect the printer (you can choose to double-click the startup button to pop up the QR code scanning connection);",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "Step 8: enter app to start printing.",
  //         imgUrls: [],
  //       },
  //     ],
  //   }, {
  //     title: "3. Printer connection problem.",
  //     details: [
  //       {
  //         theme:
  //           "(1) Abnormal Bluetooth connection: Please restart the mobile phone and printer and connect Bluetooth again. Be careful not to use the Bluetooth module of the mobile phone to connect the device directly, but to connect the device in the phomemo app;",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "(2) Sharing of multiple devices: temporarily, the device does not support simultaneous operation by multiple people. Only one mobile phone can be connected. When connecting other mobile phones, disconnect the connected mobile phones first.",
  //         imgUrls: [],
  //       }
  //     ],
  //   }, {
  //     title: "4. Unclear printing.",
  //     details: [
  //       {
  //         theme:
  //           "The title printing is not clear. Please try to adjust the printing concentration and try again;",
  //         imgUrls: [],
  //       }
  //     ],
  //   }, {
  //     title: "5. Charging problem.",
  //     details: [
  //       {
  //         theme:
  //           "(1) Charging with 5v-2a adapter takes 2 hours to fully charge. Charging with computer or adapter below 2A will increase the charging time;",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "(2) The printer can be used while charging;",
  //         imgUrls: [],
  //       }
  //     ],
  //   }, {
  //     title: "6. Other settings.",
  //     details: [
  //       {
  //         theme:
  //           "(1) Automatic shutdown duration setting: click the upper right corner of the app main interface to enter the printer connection interface, click the personal device to view and set;",
  //         imgUrls: [],
  //       }, {
  //         theme:
  //           "(2) Device power viewing: click the upper right corner of the app main interface to enter the printer connection interface, and click personal device to enter the viewing;",
  //         imgUrls: [],
  //       }
  //     ],
  //   },
  // ]
  faqData: [
    {
      title: "1. Where are the upgrades for the TP86 tattoo stencil printer?",
      details: [
        {
          theme:
            "Phomemo TP86 new anti-wrinkle mode, can effectively prevent tattoo transfer paper wrinkles, better printing results.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "2. What are the advantages of the TP86 over traditional tattoo stencil printers?",
      details: [
        {
          theme: "Phomemo TP86 tattoo printer is small and lightweight, making it easy for tattoo workers to travel with it.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "3. How to turn on anti-wrinkle mode?",
      details: [
        {
          theme:
            `Select "strong" in the print options to turn on wrinkle-resistant mode, and note that wrinkle-resistant mode leaves wrinkle lines on both sides of the tattoo transfer paper. However, you can also turn off wrinkle mode by clicking "close".`,
          imgUrls: [],
        },
      ],
    },
    {
      title: "4. What size tattoo transfer paper is supported?",
      details: [
        {
          theme:
            `The maximum size of tattoo transfer paper supported by the TP86 tattoo printer is US Letter Size (8.5" x 11"). Note that Phomemo TP86 does not support thermal paper.`,
          imgUrls: [],
        },
      ],
    },
    {
      title: "5. How long does the TP86 last on a full charge?",
      details: [
        {
          theme:
            "Phomemo TP86 tattoo printer can print 50 sheets of transfer paper on a full charge. If the print head overheats during printing, the Phomemo APP will pop up to pause the printing reminder, and you can resume printing after five minutes.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "6. Can't connect my phone with Bluetooth, what should I do?",
      details: [
        {
          theme:
            "1) Please make sure that the Bluetooth on the drop-down page is turned on and then connect the printer in the “Phomemo” APP.",
          imgUrls: [],
        }, {
          theme:
            "2) Please make sure that all permissions were allowed when installing the app or you can turn them on in the Settings of the phone.",
          imgUrls: [],
        }, {
          theme:
            "3) Please try restarting the printer and phone.",
          imgUrls: [],
        }, {
          theme:
            "4) Please try to reinstall Phomemo App or download Phomemo on another mobile phone to see if it can connect to the printer.",
          imgUrls: [],
        }, {
          theme:
            "If it still does not work, please provide us with the information below to check.",
          imgUrls: [],
        }, {
          theme:
            "1) The model and system version of your phone.",
          imgUrls: [],
        }, {
          theme:
            "2) The APP version.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "7. What to do if your printer won't print from your computer?",
      details: [
        {
          theme:
            "1) Please check whether the USB cable is connected to the TP86 tatoo printer and the computer.",
          imgUrls: [],
        }, {
          theme:
            "2) Please check whether the latest version of the driver is installed on your computer (please find the download and installation method of the driver at the top of this page).",
          imgUrls: [],
        }, {
          theme:
            "3) If there is no problem in the above two steps, please restart the computer and try again, or contact our customer service to help you solve the problem.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "8. If you follow the driver and still can not print how to solve?",
      details: [
        {
          theme:
            "If you are using Windows, ensure that you have downloaded the driver with the suffix (x64) and not (ARM). Windows and ARM versions are not compatible.",
          imgUrls: [],
        }, {
          theme:
            `Please refer to the computer driver installation guide on our APP “Phomemo” homepage and download the latest driver from our official website. Install the relevant driver according to your operating system version by following the instructions provided.`,
          imgUrls: [],
        }, {
          theme:
            `If the problem cannot be solved, please send videos or pictures of the situation to our customer service so that we can better understand it and provide you with a more effective solution.`,
          imgUrls: [],
        },
      ],
    },
    {
      title: "9. After I print out the pattern, how to transfer it onto skin?",
      details: [
        {
          theme:
            "1) Prior to transferring, it is necessary to clean the skin by wiping it with alcohol to eliminate any oils.",
          imgUrls: [],
        }, {
          theme:
            "2) Gently apply the transfer tattoo paste or deodorant onto the skin.",
          imgUrls: [],
        }, {
          theme:
            "3) Press the back side of the pattern firmly against the skin for at least 3 seconds before removing the paper.",
          imgUrls: [],
        }, {
          theme:
            "4) Allow the stenciled skin to dry for a period of 10-15 minutes.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "10. The printout is not clear, what do I have to do?",
      details: [
        {
          theme:
            "1) Please increase the print density in the APP.",
          imgUrls: [],
        }, {
          theme:
            "2) Please try to clean the print head. Wipe the cutting part of the printer, especially the black line, with alcohol cotton to ensure no dirt on the print head.",
          imgUrls: [],
        }, {
          theme:
            "3) Most of the poor printing results are printed with low quality source files. Please try to print the template in the APP and send a photo of the printed template for us to check.",
          imgUrls: [],
        }, {
          theme:
            "4) Try to replace another roll of paper for printing. It may be damp and affect the printing quality.",
          imgUrls: [],
        }, {
          theme:
            "5) Please check the battery of the printer, If it is less than 10%, please charge it in time.",
          imgUrls: [],
        }, {
          theme:
            "If none of the above methods solves the problem, please contact our customer service team.",
          imgUrls: [],
        },
      ],
    }
  ]
};

const tp87Info = {
  faqData: [
    {
      title: "1. Where are the upgrades for the TP87 tattoo stencil printer?",
      details: [
        {
          theme:
            "Phomemo TP87 new anti-wrinkle mode, can effectively prevent tattoo transfer paper wrinkles, better printing results.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "2. What are the advantages of the TP87 over traditional tattoo stencil printers?",
      details: [
        {
          theme: "Phomemo TP87 tattoo printer is small and lightweight, making it easy for tattoo workers to travel with it.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "3. How to turn on anti-wrinkle mode?",
      details: [
        {
          theme:
            `Select "strong" in the print options to turn on wrinkle-resistant mode, and note that wrinkle-resistant mode leaves wrinkle lines on both sides of the tattoo transfer paper. However, you can also turn off wrinkle mode by clicking "close".`,
          imgUrls: [],
        },
      ],
    },
    {
      title: "4. What size tattoo transfer paper is supported?",
      details: [
        {
          theme:
            `The maximum size of tattoo transfer paper supported by the TP87 tattoo printer is US Letter Size (8.5" x 11"). Note that Phomemo TP87 does not support thermal paper.`,
          imgUrls: [],
        },
      ],
    },
    {
      title: "5. How long does the TP87 last on a full charge?",
      details: [
        {
          theme:
            "Phomemo TP87 tattoo printer can print 50 sheets of transfer paper on a full charge. If the print head overheats during printing, the Phomemo APP will pop up to pause the printing reminder, and you can resume printing after five minutes.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "6. Can't connect my phone with Bluetooth, what should I do?",
      details: [
        {
          theme:
            "1) Please make sure that the Bluetooth on the drop-down page is turned on and then connect the printer in the “Phomemo” APP.",
          imgUrls: [],
        }, {
          theme:
            "2) Please make sure that all permissions were allowed when installing the app or you can turn them on in the Settings of the phone.",
          imgUrls: [],
        }, {
          theme:
            "3) Please try restarting the printer and phone.",
          imgUrls: [],
        }, {
          theme:
            "4) Please try to reinstall Phomemo App or download Phomemo on another mobile phone to see if it can connect to the printer.",
          imgUrls: [],
        }, {
          theme:
            "If it still does not work, please provide us with the information below to check.",
          imgUrls: [],
        }, {
          theme:
            "1) The model and system version of your phone.",
          imgUrls: [],
        }, {
          theme:
            "2) The APP version.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "7. What to do if your printer won't print from your computer?",
      details: [
        {
          theme:
            "1) Please check whether the USB cable is connected to the TP87 tatoo printer and the computer.",
          imgUrls: [],
        }, {
          theme:
            "2) Please check whether the latest version of the driver is installed on your computer (please find the download and installation method of the driver at the top of this page).",
          imgUrls: [],
        }, {
          theme:
            "3) If there is no problem in the above two steps, please restart the computer and try again, or contact our customer service to help you solve the problem.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "8. If you follow the driver and still can not print how to solve?",
      details: [
        {
          theme:
            "If you are using Windows, ensure that you have downloaded the driver with the suffix (x64) and not (ARM). Windows and ARM versions are not compatible.",
          imgUrls: [],
        }, {
          theme:
            `Please refer to the computer driver installation guide on our APP “Phomemo” homepage and download the latest driver from our official website. Install the relevant driver according to your operating system version by following the instructions provided.`,
          imgUrls: [],
        }, {
          theme:
            `If the problem cannot be solved, please send videos or pictures of the situation to our customer service so that we can better understand it and provide you with a more effective solution.`,
          imgUrls: [],
        },
      ],
    },
    {
      title: "9. After I print out the pattern, how to transfer it onto skin?",
      details: [
        {
          theme:
            "1) Prior to transferring, it is necessary to clean the skin by wiping it with alcohol to eliminate any oils.",
          imgUrls: [],
        }, {
          theme:
            "2) Gently apply the transfer tattoo paste or deodorant onto the skin.",
          imgUrls: [],
        }, {
          theme:
            "3) Press the back side of the pattern firmly against the skin for at least 3 seconds before removing the paper.",
          imgUrls: [],
        }, {
          theme:
            "4) Allow the stenciled skin to dry for a period of 10-15 minutes.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "10. The printout is not clear, what do I have to do?",
      details: [
        {
          theme:
            "1) Please increase the print density in the APP.",
          imgUrls: [],
        }, {
          theme:
            "2) Please try to clean the print head. Wipe the cutting part of the printer, especially the black line, with alcohol cotton to ensure no dirt on the print head.",
          imgUrls: [],
        }, {
          theme:
            "3) Most of the poor printing results are printed with low quality source files. Please try to print the template in the APP and send a photo of the printed template for us to check.",
          imgUrls: [],
        }, {
          theme:
            "4) Try to replace another roll of paper for printing. It may be damp and affect the printing quality.",
          imgUrls: [],
        }, {
          theme:
            "5) Please check the battery of the printer, If it is less than 10%, please charge it in time.",
          imgUrls: [],
        }, {
          theme:
            "If none of the above methods solves the problem, please contact our customer service team.",
          imgUrls: [],
        },
      ],
    }
  ]
};

const tp88Info = {
  guidesList: [
    {
      title: 'EN',
      url: 'https://oss.qu-in.top/printerFiles/phomemo/TPX/TP88-EN.jpg',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/gb.svg',
      key: 1,
      buryKey: 'TP88_tattoo_suppliesSales',//埋点的key
    },
    {
      title: 'JA',
      url: 'https://oss.qu-in.top/printerFiles/phomemo/TPX/TP88-JA.jpg',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/jp.svg',
      key: 2,
      buryKey: 'TP88_tattoo_suppliesSales',//埋点的key
    },
    {
      title: 'DE',
      url: 'https://oss.qu-in.top/printerFiles/phomemo/TPX/TP88-DE.jpg',
      iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/de.svg',
      key: 3,
      buryKey: 'TP88_tattoo_suppliesSales',//埋点的key
    },
    // {
    //   title: 'FR',
    //   url: 'https://pages.phomemo.com/resources/M833-快速指南.pdf',
    //   iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/fr.svg',
    //   key: 4
    // },
    // {
    //   title: 'IT',
    //   url: 'https://pages.phomemo.com/resources/M833-快速指南.pdf',
    //   iconUrl: 'https://oss.qu-in.top/printerFiles/phomemo/others/it.svg',
    //   key: 5
    // },
  ],
  faqData: [
    {
      title: "1. Are there any other uses for TP88 Tattoo Stencil Printer?",
      details: [
        {
          theme:
            "No, TP88 is a printer specifically designed for tattoo enthusiasts.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "2. After I print out the pattern, how to transfer it onto skin?",
      details: [
        {
          theme:
            "1.Prior to transferring, it is necessary to clean the skin by wiping it with alcohol to eliminate any oils.",
          imgUrls: [],
        },
        {
          theme:
            "2.Gently apply the transfer tattoo paste or deodorant onto the skin.",
          imgUrls: [],
        },
        {
          theme:
            "3.Press the back side of the pattern firmly against the skin for at least 3 seconds before removing the paper.",
          imgUrls: [],
        },
        {
          theme:
            "4.Allow the stenciled skin to dry for a period of 10-15 minutes.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "3. Do I need to replace the ink or ribbon regularly?",
      details: [
        {
          theme:
            "No. TP88 Tattoo Printer with thermal printing technology does not require additional consumables such as ink and ribbon.",
          imgUrls: [],
        },
      ],
    },
    {
      title:
        "4. What is the difference between this printer and Phomemo M08f Tattoo Stencil Printer?",
      details: [
        {
          theme:
            "TP88 tattoo printer is optimized specifically for tattoo printing. We have improved the printer's algorithms for better rendering of clear tattoo patterns. The complimentary paper is also different. TP88 has a dedicated tattoo app interface.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "5. Can't connect my phone with Bluetooth, what should I do?",
      details: [
        {
          theme:
            "1. Please make sure that the Bluetooth on the drop-down page is turned on and then connect the printer in the “Phomemo” APP.",
          imgUrls: [],
        },
        {
          theme:
            "2. Please make sure that all permissions were allowed when installing the app or you can turn them on in the Settings of the phone.",
          imgUrls: [],
        },
        {
          theme: "3. Please try restarting the printer and phone.",
          imgUrls: [],
        },
        {
          theme:
            "4. Please try to reinstall Phomemo App or download Phomemo on another mobile phone to see if it can connect to the printer.",
          imgUrls: [],
        },
        {
          theme:
            "If that still doesn't work, please use thermal paper, double-click to print the QR code, and then scan the QR code in our APP to connect.",
          imgUrls: [],
        },
        {
          theme:
            "If it still does not work, please provide us with the information below to check.",
          imgUrls: [],
        },
        {
          theme: "1. The model and system version of your phone.",
          imgUrls: [],
        },
        {
          theme: "2. The APP version.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "6. The printer has a paper jam, what do I have to do to fix it?",
      details: [
        {
          theme:
            "1. Ensure that the paper is installed correctly. Pull the paper to the correct position and close the paper bin.",
          imgUrls: [],
        },
        {
          theme:
            "2. If the paper is installed correctly, double-click the power button to print out a QR code and check if it prints normally.",
          imgUrls: [],
        },
        {
          theme:
            "3. Make sure the printer has enough power. If it is below 20%, charge it for approximately 2 hours before attempting to print again.",
          imgUrls: [],
        },
        {
          theme:
            "4. Check the print head, rubber roller, and paper outlet for any dirt or debris. Use a 5.cotton swab dipped in alcohol to clean them.",
          imgUrls: [],
        },
        {
          theme:
            "Try using thermal paper instead of tattoo paper to see if it can print normally.",
          imgUrls: [],
        },
        {
          theme:
            "5. Verify the firmware version of your printer. An outdated firmware version may cause paper jams. Please send a screenshot of the firmware version to our customer service, and we will assist you in updating it.",
          imgUrls: [],
        },
      ],
    },
    {
      title: "7. The printout is not clear, what do I have to do?",
      details: [
        {
          theme: "1. Please increase the print density in the APP.",
          imgUrls: [],
        },
        {
          theme:
            "2. Please try to clean the print head. Wipe the cutting part of the printer, especially the black line, with alcohol cotton to ensure no dirt on the print head.",
          imgUrls: [],
        },
        {
          theme:
            "3.Most of the poor printing results are printed with low quality source files. Please try to print the template in the APP and send a photo of the printed template for us to check.",
          imgUrls: [],
        },
        {
          theme:
            "4. Try to replace another roll of paper for printing. It may be damp and affect the printing quality.",
          imgUrls: [],
        },
        {
          theme:
            "5.Please check the battery of the printer, If it is less than 10%, please charge it in time.",
          imgUrls: [],
        },
        {
          theme:
            "If none of the above methods solves the problem, please contact our customer service team.",
          imgUrls: [],
        },
      ],
    },
  ],
  alsoLikeArr: [
    {
      site: 'US Paper',
      title: 'Phomemo US Letter Thermal Paper, Advanced Thermal Printing, Phomemo Thermal Printer Paper for M08F-Letter,M08F M832,M833 M834 M835 Portable Thermal Printer, Size 8.5"×11”, ...',
      allTitle: 'Phomemo US Letter Thermal Paper, Advanced Thermal Printing, Phomemo Thermal Printer Paper for M08F-Letter,M08F M832,M833 M834 M835 Portable Thermal Printer, Size 8.5"×11”, 200 Sheets',
      productUrl: 'https://www.amazon.com/gp/product/B0CR1MCRGQ',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_1.jpg'
    },
    {
      site: 'US Paper',
      title: 'Phomemo A4 Thermal Paper - White Quick-Dry Printer Paper, Multipurpose Thermal Paper Compatible for Phomemo M08F, M832, M833 Portable Thermal Printer and Brother PJ762 PJ763, ...',
      allTitle: 'Phomemo A4 Thermal Paper - White Quick-Dry Printer Paper, Multipurpose Thermal Paper Compatible for Phomemo M08F, M832, M833 Portable Thermal Printer and Brother PJ762 PJ763, 8.27"x11.69", 100 Sheets',
      productUrl: 'https://www.amazon.com/dp/B0CR1NPGX7',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_2.jpg'
    },
    {
      site: 'US Paper',
      title: 'US Letter Thermal Paper - 8.5” x 11” Quick-Dry Letter Paper, Compatible with Phomemo M08F-Letter M832 M831 M833 M834 M835 Q301 Q302 & Brother-Letter Thermal Printer for Documents ...',
      allTitle: 'US Letter Thermal Paper - 8.5” x 11” Quick-Dry Letter Paper, Compatible with Phomemo M08F-Letter M832 M831 M833 M834 M835 Q301 Q302 & Brother-Letter Thermal Printer for Documents Contracts, 100 Sheets',
      productUrl: 'https://www.amazon.com/dp/B0CRZ5KWM3',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_3.jpg'
    },
    {
      site: 'US Paper',
      title: 'Memoqueen Thermal Paper 8.5 x 11 White US Letter Thermal Printer Paper Compatible with M08F Letter, M832, M834, M835, MT800 Portable Printer, Quick-Dry Size 8.5" x 11" Business Paper ...',
      allTitle: 'Memoqueen Thermal Paper 8.5 x 11 White US Letter Thermal Printer Paper Compatible with M08F Letter, M832, M834, M835, MT800 Portable Printer, Quick-Dry Size 8.5" x 11" Business Paper Label, 100 Sheets',
      productUrl: 'https://www.amazon.com/dp/B0CQZWPNHY',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_4.png'
    },
    {
      site: 'US Paper',
      title: 'Phomemo A4 Quick-dry Continuous Thermal Paper, 8.27"x275 3/5" (210mm*6.5m) width, black text, 4 Rolls in box. Compatible with Phomemo M08F/M832/M833/M834 portable A4 printer. Storage...',
      allTitle: 'Phomemo A4 Quick-dry Continuous Thermal Paper, 8.27"x275 3/5" (210mm*6.5m) width, black text, 4 Rolls in box. Compatible with Phomemo M08F/M832/M833/M834 portable A4 printer. Storage for 10 years',
      productUrl: 'https://www.amazon.com/gp/product/B0CR1MFNK4',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/US_5.png'
    },


    {
      site: 'CA Paper',
      title: "Letter Thermal Paper 2 Rolls, Thermal Printer Paper Roll for Quick-Drying, Compatible with Phomemo M08F-Letter M832/M833 Portable Printer, Size 8.5’’ x 11’’, File Keep for 10 Years",
      allTitle: 'Letter Thermal Paper 2 Rolls, Thermal Printer Paper Roll for Quick-Drying, Compatible with Phomemo M08F-Letter M832/M833 Portable Printer, Size 8.5’’ x 11’’, File Keep for 10 Years',
      productUrl: 'https://www.amazon.ca/dp/B0CRL95HDN',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_1.png'
    },
    {
      site: 'CA Paper',
      title: `Letter Thermal Paper, White Fast-Drying Folding Thermal Paper, Advanced Thermal Printing, Compatible with Phomemo M08F, M832, M833, with Other Letter Portable Printer,Size 8.5" x 11",...`,
      allTitle: 'Letter Thermal Paper, White Fast-Drying Folding Thermal Paper, Advanced Thermal Printing, Compatible with Phomemo M08F, M832, M833, with Other Letter Portable Printer,Size 8.5" x 11",200 Sheets',
      productUrl: 'https://www.amazon.ca/dp/B0CRL84PVM',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_2.png'
    },
    {
      site: 'CA Paper',
      title: "Thermal Paper 8.5 x 11 Inch, Letter Thermal Printer Paper, Advance Thermal Printing for Quick-Dry, Compatible with M08F-Letter, M832/M833, MT800 Letter Portable Printer,200 Sheets",
      allTitle: 'Thermal Paper 8.5 x 11 Inch, Letter Thermal Printer Paper, Advance Thermal Printing for Quick-Dry, Compatible with M08F-Letter, M832/M833, MT800 Letter Portable Printer,200 Sheets',
      productUrl: 'https://www.amazon.ca/dp/B0CRL8HFKP',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_3.png'
    },
    {
      site: 'CA Paper',
      title: "Thermal Printer Paper, A4 Thermal Paper Roll for Quick-Dry, Advance Thermal Printing for A4 Portable Printer, Compatible with M08F M832 M833 Portable Printer,2 Rolls",
      allTitle: 'Thermal Printer Paper, A4 Thermal Paper Roll for Quick-Dry, Advance Thermal Printing for A4 Portable Printer, Compatible with M08F M832 M833 Portable Printer,2 Rolls',
      productUrl: 'https://www.amazon.ca/dp/B0CRL7PJTV',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_4.png'
    },
    {
      site: 'CA Paper',
      title: "Thermal Paper A4, Thermal Printer Paper for A4 Portable Printer, Advanced Thermal Printing Quick-Dry,Compatible with Phomemo M08F-A4, M832, M833, with Brother A4 Portable Printer, 200 Sheets",
      allTitle: 'Thermal Paper A4, Thermal Printer Paper for A4 Portable Printer, Advanced Thermal Printing Quick-Dry,Compatible with Phomemo M08F-A4, M832, M833, with Brother A4 Portable Printer, 200 Sheets',
      productUrl: 'https://www.amazon.ca/dp/B0CRL87VB9',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/CA_5.png'
    },

    {
      site: 'UK Paper',
      title: 'Phomemo A4 Thermal Printer Paper, 210mm x 6.5m (8.27" x 256"), Compatible with Phomemo M08/M08F/M831/ M832/M833/M834 Portable A4 Printer, for Travel, Home, Office, Photos, Invoices, ...',
      allTitle: 'Phomemo A4 Thermal Printer Paper, 210mm x 6.5m (8.27" x 256"), Compatible with Phomemo M08/M08F/M831/M832/M833/M834 Portable A4 Printer, for Travel, Home, Office, Photos, Invoices, Contracts, 2 Rolls',
      productUrl: 'https://www.amazon.co.uk/dp/B0CR1BJ3L3?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_1.jpeg'
    },
    {
      site: 'UK Paper',
      title: 'Phomemo A4 Thermal Printer Paper - 210mm x 6.5m (8.27" x 256"), Compatible with Phomemo M08/M831/M832/ M833/M834 Portable A4 Printer, for Travel, Home, Office, Photos, Invoices, ...',
      allTitle: 'Phomemo A4 Thermal Printer Paper - 210mm x 6.5m (8.27" x 256"), Compatible with Phomemo M08/M831/M832/M833/M834 Portable A4 Printer, for Travel, Home, Office, Photos, Invoices, Contracts, 4 Rolls',
      productUrl: 'https://www.amazon.co.uk/dp/B0CR18WS6J?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_2.png'
    },
    {
      site: 'EU Paper',
      title: 'Phomemo A4 Thermal Printer Paper, 210 mm x 7 m (8.27 x 276 inches), BPA-Free, Compatible with Phomemo M831/M832/M833 Mobile A4 Printer, for Travel, Home, Office, Photos, Bills, ...',
      allTitle: 'Phomemo A4 Thermal Printer Paper, 210 mm x 7 m (8.27 x 276 inches), BPA-Free, Compatible with Phomemo M831/M832/M833 Mobile A4 Printer, for Travel, Home, Office, Photos, Bills, Contracts, Tattoo, ...',
      productUrl: 'https://www.amazon.de/dp/B0CR3QLF95?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_3.jpeg'
    }, {
      site: 'EU Paper',
      title: 'Phomemo A4 Thermal Printer Paper, 4 Rolls, 210 mm x 7 m (8.27 x 276 inches), BPA-Free, Compatible with Phomemo M831/M832/M833 Mobile A4 Printer, for Travel, Home, Office, Photos, Bills...',
      allTitle: 'Phomemo A4 Thermal Printer Paper, 4 Rolls, 210 mm x 7 m (8.27 x 276 inches), BPA-Free, Compatible with Phomemo M831/M832/M833 Mobile A4 Printer, for Travel, Home, Office, Photos, Bills, Contracts',
      productUrl: 'https://www.amazon.de/dp/B0CR41JGBQ?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_4.jpeg'
    }, {
      site: 'EU Paper',
      title: 'Phomemo A4 Continuous Folding Thermal Paper, 210 mm x 297 mm (8.27 x 11.69 inches), Compatible with Phomemo M831/M832/M833 Portable A4 Printer, for Business, Home, Photo,...',
      allTitle: 'Phomemo A4 Continuous Folding Thermal Paper, 210 mm x 297 mm (8.27 x 11.69 inches), Compatible with Phomemo M831/M832/M833 Portable A4 Printer, for Business, Home, Photo, Invoice, Contract, Tattoo',
      productUrl: 'https://www.amazon.de/dp/B0CR3PNP32?ref=myi_title_dp',
      img: 'https://oss.qu-in.top/printerFiles/phomemo/M833/EU_5.jpeg'
    },
  ]
};
export { faqDataApp, tattooFaq, m832Info, m833Info, faqDataAppForT310, tp86Info, tp87Info, tp88Info };



// WEBPACK FOOTER //
// ./src/view/guides/dataConfig.js